import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { content, contactInfo } from '../data/mock';
import './CTA.css';

const CTA = ({ language }) => {
  const t = content[language].cta;

  return (
    <section>
      <div className="container">
        <div className="cta">
          <div>
            <h2 style={{ margin: '0 0 0.45rem' }}>{t.title}</h2>
            <p>{t.description}</p>
          </div>
          <div className="cta-actions">
            <a
              className="btn btn-secondary"
              href={contactInfo.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp size={22} />
              {t.btn1}
            </a>
            <a className="btn btn-outline" href={`tel:${contactInfo.phone}`}>
              {t.btn2}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
